import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Link } from '@mui/material';
import DOMPurify from 'dompurify';
import '../styles/articledialog.css';

const ArticleDialog = ({ open, onClose, article }) => {
    //If the HTML content comes from an untrusted source, it is crucial to sanitize it to prevent XSS attacks. 
    //You can use libraries like dompurify to sanitize the HTML content before rendering it.
    const sanitizedHTML =
        article.article?.content 
            ? DOMPurify.sanitize(article.article?.content)
            : 'No full article available';
    //console.log("Article content: ", sanitizedHTML);
    //The dangerouslySetInnerHTML attribute is used to set the HTML content directly from the string.
    //Wrap HTML Content in a div: The HTML content is wrapped in a div element to ensure it is rendered correctly.

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>{article.title}</DialogTitle>
            <DialogContent sx={{ overflowX: 'hidden' }}>
                
                <Typography variant="subtitle1" gutterBottom>
                    <span>Below is a cached version. Read the original article at: </span>
                    <Link href={article.link} target="_blank" rel="noopener" title={article.link}>
                        {article.link.substring(0, 50)}...
                    </Link>
                </Typography>
                <Typography variant="body1" component="div">
                    {article.article?.content && (
                        <div className="article-content"
                            dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
                        />
                    )} 
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ArticleDialog;